<div class="container p-space-xs">
  <div class="row align-items-center">
    <div class="col-10 pt-space-0">list of tag</div>
    <div class="col-2">
      <cam-link (action)="this.changeFilterOpen()">
        <cam-font-icon [name]="this.isFilterOpen ? 'check-line' : 'filter-tool'" type="lg"></cam-font-icon>
      </cam-link>
    </div>
  </div>
</div>
<div class="list">
  <cam-layout-with-panel [open]="this.isFilterOpen">
    <cam-layout-panel>
      <cam-filters-form></cam-filters-form>
    </cam-layout-panel>
    <cam-layout-content>
      <ng-content></ng-content>
    </cam-layout-content>
  </cam-layout-with-panel>
</div>
